// extracted by mini-css-extract-plugin
export var columnList = "_dn-0";